import React, { ReactNode, CSSProperties } from 'react';
import { useHistory } from 'react-router-dom';

interface IProps {
	children?: ReactNode | ReactNode[]
	href: string,
	onClick?: (href?: string) => void,
	style?: CSSProperties,
	className?: string
}

const AppLink = (props: IProps) => {
	const history = useHistory();

	function onClick() {
		if (props.onClick) {
			props.onClick(props.href);
		} else {
			history.push(props.href);
		}
	}

	let className = 'app-link';
	if (props.className) className += ' ' + props.className;

	return (
		<span className={className} style={props.style} onClick={onClick}>
			{props.children}
		</span>
	);
};

export default AppLink;